import React from 'react'
import BlueArrow from './arrowBlue.svg'
import WhiteArrow from './arrowWhite.svg'
import LightBlue from './arrowLightBlue.svg'
import YellowArrow from './arrowYellow.svg'
import PropTypes from 'prop-types'

const Arrow = (props) => {
    switch (props.color) {
        case 'white':
            return <img src={WhiteArrow} alt="" width={props.size} />
        case 'lightBlue':
            return <img src={LightBlue} alt="" width={props.size} />
        case 'yellow':
            return <img src={YellowArrow} alt="" width={props.size} />
        case 'blue':
            return <img src={BlueArrow} alt="" width={props.size} />
        default:
            return <img src={YellowArrow} alt="" width={props.size} />
    }
}

Arrow.propTypes = {
    color: PropTypes.string,
    size: PropTypes.string,
}

Arrow.defaultProps = {
    color: 'white',
    size: '40',
}

export default Arrow
